"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topLogoUrl = exports.getVideoUrls = void 0;
var _utils = require("@site/utils");
const getVideoUrls = () => {
  const getVideoUrl = video => `${(0, _utils.getImagesBaseUrl)()}conversationalSearch/${video}`;
  return {
    welcomeWebmVideoUrl: getVideoUrl('aiEnterQuery.webm'),
    welcomeMp4VideoUrl: getVideoUrl('aiEnterQuery.mp4'),
    loadingWebmVideoUrl: getVideoUrl('aiLoadThumb.webm'),
    loadingMp4VideoUrl: getVideoUrl('aiLoadThumb.mp4')
  };
};
exports.getVideoUrls = getVideoUrls;
const topLogoUrl = exports.topLogoUrl = 'https://img1.wsimg.com/cdnassets/transform/2802c59c-db45-442f-9a0c-919b4b9768f0/img-hp-airo-logo';